import { render, staticRenderFns } from "./ArrowLeft.vue?vue&type=template&id=2fa7d188&scoped=true"
import script from "./ArrowLeft.vue?vue&type=script&lang=js"
export * from "./ArrowLeft.vue?vue&type=script&lang=js"
import style0 from "./ArrowLeft.vue?vue&type=style&index=0&id=2fa7d188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7d188",
  null
  
)

export default component.exports